var map = {
	"./de.json": 335106,
	"./en.json": 833310,
	"./es.json": 405413,
	"./fr.json": 441259,
	"./it.json": 295389,
	"./ja.json": 737113,
	"./ko.json": 674248,
	"./pl.json": 212649,
	"./pt.json": 807543,
	"./ru.json": 888849,
	"./uk.json": 766475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194559;